import "../tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most
 *                  tools just pass the component context to their templates,
 *                  so that's the default
 *  tool.render - by default updates the tool element with markup generated by
 *                tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext
 *    and update. update is
 *  - identical to render by default, but you can override it. the update
 *    lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context
 *    value, you update your view there.
 */

/* global dragula */

(function (dragula, Event) {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "collection-editor",

    /**
     * @description The template file to use to load and render the component.
     */
    templateId: "collection-editor-template",

    /**
     * @description Unique selectors from the template to control events.
     */
    selectors: {
      container: ".collection-editor-container",
      item: ".collection-item",
      itemEdit: ".editor-fields-container",
      itemLabel: ".collection-item__header-label",
      add: '[data-collection-editor-behaviour="add-collection-item"]',
      remove: '[data-collection-editor-behaviour="remove-collection-item"]',
      enabledClass: "--enabled",
      reorderInput: '[data-collection-editor-behaviour="reorder-input"]',
    },

    // EVENT HANDLERS

    /**
     * @name onDrop
     * @description
     * Update component context when items are reordered using the draggula
     *  drag and drop handler.
     * Rerender both the tool and component so they stay in sync.
     * @param droppedItem, dropContainer
     */
    onItemReorder: function (item, container) {
      var previousOrderItems = this.component.context.items;
      var sortedItems = jQuery(this.element).find(this.selectors.item);
      var reorderedItems = [];

      sortedItems.each(function (_index, item) {
        var previousIndex = jQuery(item).data("index");
        var itemContext = previousOrderItems[previousIndex];
        reorderedItems.push(itemContext);
      });

      this.component.context.items = reorderedItems;
      this.persistAndRender();
    },

    /**
     * @name itemClicked
     * @description Enable the item for editing when clicked.
     */
    itemClicked: function (event) {
      if (jQuery(event.target).is(this.selectors.reorderInput)) {
        return;
      }
      var item = jQuery(event.currentTarget);
      this.enableItem(item);
    },

    onReorderInput: function (event) {
      event.stopPropagation();

      var input = jQuery(event.currentTarget);
      var itemElement = input.closest(this.selectors.item);
      var currentIndex = itemElement.data("index");
      var items = this.component.context.items;
      var totalItems = items.length;

      var rawValue = input.val().trim();
      if (rawValue === "") {
        return;
      }
      var desiredPosition = parseInt(rawValue, 10);
      if (isNaN(desiredPosition) || desiredPosition < 1) {
        desiredPosition = 1;
      }
      if (desiredPosition > totalItems) {
        desiredPosition = totalItems;
      }
      var targetIndex = desiredPosition - 1;

      if (targetIndex === currentIndex) {
        input.val(currentIndex + 1);
        return;
      }

      var removed = items.splice(currentIndex, 1)[0];
      items.splice(targetIndex, 0, removed);

      this.persistAndRender();

      var newInput = jQuery(this.element).find(this.selectors.item).eq(targetIndex).find(this.selectors.reorderInput);
      var el = newInput[0];
      // Clear and re-set the value to place the cursor at the end.
      // setSelectionRange doesn't work on input[type="number"].
      var val = el.value;
      el.focus();
      el.value = "";
      el.value = val;
    },

    /**
     * @name addItemClicked
     * @description
     *   Add a new item with the empty values for attributes
     *   Rerender both the tool and component so they stay in sync.
     *   Enable the new item for editing.
     */
    addItemClicked: function () {
      var itemIndex = this.component.context.items.length;
      this.component.context.items[itemIndex] = {};
      this.persistAndRender();

      var newItemElement = jQuery(this.element).find(this.selectors.item)[itemIndex];
      this.enableItem(newItemElement);
    },

    removeItemClicked: function (event) {
      var index = jQuery(event.target).data("index");
      var me = this;
      swal(
        {
          title: "Please Confirm",
          text: "Are you sure you want to remove this item?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        function () {
          me.removeItem(index);
        },
      );
    },

    // HELPER FUNCTIONS
    initializeCollection: function () {
      var me = this;
      this.unloadItemLoaders();
      jQuery(this.element)
        .find(this.selectors.item)
        .each(function (index, item) {
          me.initializeItem(index, item);
        });
    },

    unloadItemLoaders: function () {
      var unloadError;
      var itemLoaders = this.itemLoaders || [];

      this.itemLoaders = [];
      itemLoaders.forEach(function (loader) {
        try {
          loader.unload();
        } catch (error) {
          unloadError = unloadError || error;
        }
      });

      if (unloadError) {
        throw unloadError;
      }
    },

    initializeItem: function (index, item) {
      var fields = jQuery('<div class="tools">');
      var itemLabel = this.component.config.item.label || "Item";
      var loader = Sparkle.PageBuilder.Tool.Loader(this.component, fields.get(0));
      loader.load(this.component.config.item.attributes, "items." + index + ".");
      this.itemLoaders.push(loader);

      jQuery(item).find(this.selectors.itemLabel).empty();
      jQuery(item).find(this.selectors.itemLabel).append(itemLabel);
      jQuery(item).find(this.selectors.itemEdit).append(fields);
    },

    enableItem: function (item) {
      jQuery(this.element).find(this.selectors.item).removeClass(this.selectors.enabledClass);
      jQuery(item).addClass(this.selectors.enabledClass);
    },

    removeItem: function (itemIndex) {
      this.component.context.items.splice(itemIndex, 1);
      this.persistAndRender();
    },

    persistAndRender: function () {
      this.component.save();
      this.component.render();
      this.render();
      this.initializeCollection();
    },

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component, and also add in
     *  any extra functionality to manage the slideshow
     * @param {HTMLElement} component
     */
    bind: function (component) {
      var me = this;
      var container = jQuery(this.element).find(this.selectors.container)[0];

      this.drake = dragula({
        containers: [container],
        // Only containers inside this tool's element. Other collection-editor instances use the same class.
        isContainer: function (element) {
          return me.element.contains(element) && element.classList.contains(me.selectors.container.slice(1));
        },
        invalid: function (element) {
          return !element.classList.contains(me.selectors.item.slice(1)); // Only items are draggable
        },
      });

      // Initialize
      this.initializeCollection();

      // Event Handlers
      this.drake.on("cloned", function (clone) {
        jQuery(clone).children().not(".collection-item__header").remove();
      });
      this.drake.on("drop", this.onItemReorder.bind(this));
      jQuery(this.element).on("click", this.selectors.item, this.itemClicked.bind(this));
      jQuery(this.element).on("click", this.selectors.add, this.addItemClicked.bind(this));
      jQuery(this.element).on("click", this.selectors.remove, this.removeItemClicked.bind(this));
      jQuery(this.element).on("change", this.selectors.reorderInput, this.onReorderInput.bind(this));
      jQuery(this.element).on("keydown", this.selectors.reorderInput, function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          e.currentTarget.blur();
        }
      });
      jQuery(this.element).on("click", this.selectors.reorderInput, function (e) {
        e.stopPropagation();
      });
    },

    unbind: function (component) {
      var drake = this.drake;

      this.drake = null;
      try {
        this.unloadItemLoaders();
      } finally {
        if (drake) {
          drake.destroy();
        }
      }
    },

    shouldBeCustomizedOnClick: function () {
      return false;
    },
  });
})(dragula, Sparkle.PageBuilder.Helpers.Event);
